import React, { useEffect, useState } from 'react'
import { Rules } from '@orbital/games-frontend-library'
import {
  GAME_DESCRIPTION,
  settings,
  GameplayCustomization,
  RaiseContent,
  FoldContent,
} from 'components/gameRules/CONTENT'
import { useCardCombinations } from './CUSTOM_RULES_CONTENT'
import { CustomButton } from './CustomRulesStyled'
import { BetButton } from '../footer/betButtons/BetButtonsStyles'
import { ReactComponent as RaiseSVG } from 'lib/assets/raise.svg'
import { COEFS } from './interface'
import Combinations from './Combinations'

const MAX_WIN = 200

export default function CustomRules(coefs: COEFS) {
  const [ante, setAnte] = useState<string[]>([''])
  const [aa, setAA] = useState<string[]>([''])
  const [anteCombinations] = useCardCombinations(ante)
  const [aaCombinations] = useCardCombinations(aa)

  useEffect(() => {
    setAnte(coefs.coefs.ante && coefs.coefs.ante)
    setAA(coefs.coefs.aa && coefs.coefs.aa)
  }, [coefs.coefs.ante, coefs.coefs.aa])

  return (
    <>
      <div>
        <h3>{GAME_DESCRIPTION.title}</h3>
        {GAME_DESCRIPTION.description.map((text, id) => (
          <p key={id}>{text}</p>
        ))}
        <p>
          The max win is {`${coefs.currency} ${coefs.maxBet * MAX_WIN}`} of your
          bet
        </p>
        <p>
          Maximum Bet: {`${coefs.currency} ${coefs.maxBet}`} Minimum Bet:{' '}
          {`${coefs.currency} ${coefs.minBet}`}
        </p>
      </div>
      <h3>Settings</h3>
      <Rules content={settings} />
      <h3>Gameplay Customization</h3>
      <Rules content={GameplayCustomization} />
      <CustomButton raise>
        <BetButton raise width='105px' className='bet-button'>
          <div className='btn'>
            <RaiseSVG />
            <span>RAISE</span>
          </div>
        </BetButton>
        <Rules content={RaiseContent} />
      </CustomButton>
      <CustomButton>
        <BetButton raise width='105px' className='bet-button'>
          <div className='btn'>
            <RaiseSVG />
            <span>FOLD</span>
          </div>
        </BetButton>
        <Rules content={FoldContent} />
      </CustomButton>
      <h3>Ante bet Winning Combinations</h3>
      <Combinations coefs={anteCombinations} />
      <h3>AA bet Winning Combinations</h3>
      <Combinations coefs={aaCombinations} />
      <div></div>
    </>
  )
}
